import { BiError } from "react-icons/bi";
import { InputGroup, InputNumber as InputRs, InputNumberProps } from "rsuite";
interface Props extends InputNumberProps {
  label?: string;
  error?: string;
  touched?: any;
  noarrow?: boolean;
}
const InputNumber = ({
  touched,
  noarrow = false,
  label,
  error,
  ...rest
}: Props) => {
  return (
    <>
      {label && <div className="fw-bold font-size-14">{label}</div>}

      {label && (
        <div className="fw-bold font-size-14 mb-1">
          {label}
          {error && <span className="text-danger">{"*"}</span>}
        </div>
      )}

      <InputGroup style={{}} className={"customInput mb-4"}>
        <InputRs
          {...rest}
          className={
            (error && touched ? "customInput errorInput" : "") +
            (noarrow ? " noarrowinputnumber" : "")
          }
        />
        {error && touched && (
          <InputGroup.Addon className="bg-danger  fw-bold">
            <div data-tooltip={error}>
              <BiError size={18} className="text-light" />
            </div>
          </InputGroup.Addon>
        )}
      </InputGroup>
    </>
  );
};
export default InputNumber;
